import React from "react";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { withStepsState } from "../../../shared/containers/containerStepsState"
import AnimatedProgressProvider from "./AnimatedProgressProvider";
import TextSlider from './textSlider/textSlider'
import SliderReview from './sliderReview/sliderReview'
import VervBar from './vervBar/vervBar'
import { easeQuadInOut } from 'd3-ease';
import './styles.css';
import styles from './loader.module.scss'
import locales from "../../../content.json"

import bubbles from './img/bubles.png'

const Loader = (props) => {

  function durationTimer() {
    props.onOpenResultPage();
  }

  return (
    <>
      {props.openLoaderResult ?
          <div className={styles.container}>
            <VervBar />
            <div className={styles.container_circle}>
              <img className={styles.container_circle_bubbles} src={bubbles} alt={"bubbles"}/>
              <AnimatedProgressProvider
                valueStart={0}
                valueEnd={100}
                duration={15}
                easingFunction={easeQuadInOut}
                timer={setTimeout(durationTimer, 15500)}
              >
                {(value) => {
                  const roundedValue = Math.round(value);
                  return (
                    <CircularProgressbar
                      className={styles.loader}
                      value={value}
                      text={`${roundedValue}%`}
                      strokeWidth={10}
                      background
                      backgroundPadding={2}
                      styles={buildStyles({
                        backgroundColor: "#FFF",
                        textColor: "#303030",
                        pathColor: "#A054DA",
                        trailColor: "rgba(159, 113, 235, 0.2)",
                        pathTransitionDuration: "5s",
                      })}
                    />
                  );
                }}
              </AnimatedProgressProvider>
            </div>
            <TextSlider />
            <div className={styles.container_aboutLoader_description}>
              {locales[window.userLang].loader_slider_description}
            </div>
            <SliderReview />
          </div>
        : null
      }
    </>
  )
}

export default withStepsState(Loader);